import { Directive, ElementRef, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[appIntersectionObserver]'
})
export class IntersectionObserverDirective implements OnInit, OnDestroy {
  @Input() options: IntersectionObserverInit = { threshold: 0.2 };
  @Output() intersectionChange = new EventEmitter<boolean>();

  private observer!: IntersectionObserver;

  constructor(private element: ElementRef, @Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) { // ✅ Only run in the browser
      this.observer = new IntersectionObserver(([entry]) => {
        this.intersectionChange.emit(entry.isIntersecting);
      }, this.options);

      this.observer.observe(this.element.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId) && this.observer) { // ✅ Prevent errors on the server
      this.observer.disconnect();
    }
  }
}
